/**
 * profileStyles.js — static StyleSheet extracted from ProfilePage.jsx
 * (god-file decomposition). Purely presentational constants; no logic.
 */

import { StyleSheet, Platform } from 'react-native';
import { responsive } from '../utils/responsive';

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#000000',
    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#000000',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
    },
    splashContainer: {
        flex: 1,
        width: '100%',
        height: '100%',
        paddingHorizontal: responsive(16, 32, Platform.OS === 'web' ? 48 : 24),
        paddingTop: responsive(12, 20, Platform.OS === 'web' ? 32 : 16),
        paddingBottom: responsive(16, 32, Platform.OS === 'web' ? 48 : 24),
        gap: responsive(24, 36, 48),
    },
    mainContent: {
        flex: 1,
        borderRadius: responsive(12, 16, 20),
        backgroundColor: '#000',
        padding: responsive(12, 18, 24),
        borderWidth: 1,
        borderBottomWidth: 2,
        borderTopColor: 'rgba(255,255,255,0.25)',
        borderLeftColor: 'rgba(255,255,255,0.18)',
        borderRightColor: 'rgba(255,255,255,0.12)',
        borderBottomColor: 'rgba(255,255,255,0.08)',
    },
    mainContentBlur: {
        flex: 1,
        borderRadius: responsive(12, 16, 20),
    },
    scrollView: {
        flex: 1,
    },
    settingsContainer: {
        width: '100%',
        paddingVertical: 24,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        overflow: 'hidden',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    settingsTitle: {
        alignSelf: 'stretch',
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: responsive(20, 24, 28),
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: responsive(24, 28, 32),
    },
    // Usage card styles
    usageCard: {
        alignSelf: 'stretch',
        marginTop: 20,
        marginBottom: 8,
        marginHorizontal: responsive(12, 20, 24),
        padding: responsive(16, 20, 24),
        borderRadius: 16,
        backgroundColor: 'rgba(139, 92, 246, 0.08)',
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.2)',
    },
    usageHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 16,
    },
    usageHeaderLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    usageTitle: {
        color: '#e9e9e9',
        fontSize: 15,
        fontWeight: '600',
    },
    usagePlanBadge: {
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 12,
        backgroundColor: 'rgba(255,255,255,0.1)',
    },
    usagePlanBadgePro: {
        backgroundColor: 'rgba(139, 92, 246, 0.3)',
    },
    usagePlanBadgeUltimate: {
        backgroundColor: 'rgba(251, 191, 36, 0.3)',
    },
    usagePlanBadgeAdmin: {
        backgroundColor: 'rgba(74, 222, 128, 0.3)',
        borderWidth: 1,
        borderColor: 'rgba(74, 222, 128, 0.5)',
    },
    usagePlanText: {
        color: '#fff',
        fontSize: 11,
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    usageStats: {
        alignItems: 'center',
        marginBottom: 12,
    },
    usageCount: {
        fontSize: 28,
        fontWeight: '300',
        color: 'rgba(255,255,255,0.7)',
    },
    usageCountHighlight: {
        color: '#a78bfa',
        fontWeight: '700',
    },
    usageCountDivider: {
        color: 'rgba(255,255,255,0.4)',
    },
    usageLabel: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 13,
        marginTop: 2,
    },
    usageProgressContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    usageProgressBg: {
        flex: 1,
        height: 8,
        borderRadius: 4,
        backgroundColor: 'rgba(255,255,255,0.1)',
        overflow: 'hidden',
    },
    usageProgressFill: {
        height: '100%',
        borderRadius: 4,
    },
    usagePercentage: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 12,
        fontWeight: '600',
        minWidth: 36,
        textAlign: 'right',
    },
    usageFooter: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 12,
    },
    usageRemaining: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 12,
    },
    usageLimitReached: {
        color: '#f87171',
        fontSize: 12,
        fontWeight: '500',
    },
    usageUpgradeBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderRadius: 8,
        backgroundColor: 'rgba(139, 92, 246, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    usageUpgradeBtnText: {
        color: '#a78bfa',
        fontSize: 12,
        fontWeight: '600',
    },
    tabBtn: {
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.14)'
    },
    tabBtnActive: {
        backgroundColor: 'rgba(255,255,255,0.10)',
        borderColor: 'rgba(255,255,255,0.28)'
    },
    tabBtnText: { color: 'rgba(255,255,255,0.8)', fontWeight: '600' },
    tabBtnTextActive: { color: '#fff' },
    profileSection: {
        width: '100%',
        maxWidth: 900,
        paddingVertical: 24,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        gap: 32,
        display: 'flex',
        flexDirection: 'row',
    },
    profileImageContainer: {
        width: 84,
        height: 84,
        position: 'relative',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25) inset',
        borderRadius: 999,
        // Add subtle border to indicate it's clickable
    },
    profileImageBackground: {
        width: 84,
        height: 84,
        position: 'absolute',
        left: 0,
        top: 0,
        borderRadius: 999,
        borderWidth: 3,
        overflow: 'hidden',
        borderColor: 'transparent',
    },
    profileImageGradient: {
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    profileImage: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        objectFit: 'cover',
    },
    profileImagePlaceholder: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        flexDirection: 'column',
        marginBottom: 5,
        gap: 2,
    },
    uploadText: {
        color: 'rgba(255, 255, 255, 0.60)',
        fontSize: 10,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 16,
        textAlign: 'center',
    },
    profileInfo: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        display: 'flex',
    },
    profileHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    profileLabel: {
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 16,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 16,
    },
    planCard: {
        flexDirection: 'row',
        gap: 10,
        paddingHorizontal: 12,
        paddingVertical: 10,
        minWidth: 120,
    },
    planText: {
        fontSize: 18,
        fontFamily: 'Slate',
        fontWeight: '500',
        color: 'rgba(255, 255, 255, 0.9)',
        textAlign: 'right',
    },
    profileInput: {
        alignSelf: 'stretch',
        borderRadius: 4,
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 8,
        display: 'flex',
    },
    customInputContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        borderRadius: 4,
        padding: 0,
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.4)',
        borderLeftColor: 'rgba(255,255,255,0.3)',
        borderRightColor: 'rgba(0,0,0,0.3)',
        borderBottomColor: 'rgba(0,0,0,0.4)',
        overflow: 'hidden',
        // Embossed effect with shadows
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 2,
        elevation: 2,
        // Inner shadow for embossed look
        ...(Platform.OS === 'web' && {
            boxShadow: 'inset 0 1px 2px rgba(255,255,255,0.2), inset 0 -1px 2px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)',
        }),
    },
    customInputBlur: {
        flex: 1,
        width: '100%',
        height: '100%',
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
    },
    customInputText: {
        flex: 1,
        color: '#B5B5B5',
        fontSize: 15,
        padding: 0,
        fontFamily: 'Slate',
        fontWeight: '400',
        // background shorthand removed for RNW
        backgroundColor: 'transparent',
        lineHeight: 20,
        width: '100%',
        ...(Platform.OS === 'web' ? { outlineStyle: 'none' } : {}),
    },
    section: {
        width: '100%',
        maxWidth: 900,
        paddingVertical: 24,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        overflow: 'hidden',
        borderTopWidth: 2,
        borderTopColor: 'rgba(255, 255, 255, 0.80)',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 16,
        display: 'flex',
    },
    sectionTitle: {
        alignSelf: 'stretch',
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 20,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 24,
    },
    inputRow: {
        alignSelf: 'stretch',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 16,
        display: 'flex',
        flexDirection: 'row',
    },
    inputGroup: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        display: 'flex',
    },
    inputLabel: {
        alignSelf: 'stretch',
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 13,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 16,
    },
    inputContainer: {
        alignSelf: 'stretch',
        paddingHorizontal: 12,
        paddingVertical: 8,
        // gradient handled via overlays; remove shorthand
        borderRadius: 4,
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 8,
        display: 'flex',
    },
    input: {
        flex: 1,
        color: '#B5B5B5',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 20,
    },
    preferenceItem: {
        alignSelf: 'stretch',
        paddingVertical: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 16,
        display: 'flex',
    },
    preferenceTitle: {
        alignSelf: 'stretch',
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 17,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 24,
    },
    preferenceDescription: {
        alignSelf: 'stretch',
        color: '#B5B5B5',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 20,
    },
    sportsbookFiltersContainer: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        display: 'flex',
        gap: 12,
    },
    sportsbookUnifiedGrid: {
        gap: 8,
        display: 'flex',
        flexDirection: 'column',
    },
    sportsbookUnifiedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 8,
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.08)',
    },
    sportsbookUnifiedCheckbox: {
        paddingRight: 8,
    },
    sportsbookUnifiedName: {
        color: 'rgba(255, 255, 255, 0.70)',
        fontSize: 14,
        fontFamily: 'Slate',
        fontWeight: '400',
        flex: 1,
    },
    sportsbookUnifiedLimitInput: {
        width: 80,
        textAlign: 'right',
    },
    customCheckbox: {
        width: 14,
        height: 14,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: 2,
    },
    customCheckboxSelected: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.8)',
    },
    checkbox: {
        width: 14,
        height: 14,
        backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    sportsbookName: {
        color: '#B5B5B5',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 20,
    },
    limitValue: {
        width: 50,
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 0.10)',
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        display: 'flex',
    },
    limitValueText: {
        color: 'white',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    settingRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 14,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.06)',
        gap: 16,
    },
    settingInfo: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 3,
    },
    settingTitle: {
        color: 'rgba(255,255,255,0.85)',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    settingDescription: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 13,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 18,
        marginTop: 2,
    },
    settingValue: {
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    },
    settingValueGradient: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: 4,
    },
    settingValueText: {
        color: 'white',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    toggleRow: {
        alignSelf: 'stretch',
        paddingVertical: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 16,
        display: 'flex',
        flexDirection: 'row',
    },
    toggleInfo: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        display: 'flex',
    },
    toggleTitle: {
        alignSelf: 'stretch',
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 17,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 24,
    },
    toggleDescription: {
        alignSelf: 'stretch',
        color: '#B5B5B5',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 20,
    },
    toggleSwitch: {
        width: 72,
        height: 36,
        position: 'relative',
        backgroundColor: 'rgba(255, 255, 255, 0.10)',
        overflow: 'hidden',
        borderRadius: 999,
        borderWidth: 1.5,
        borderBottomColor: 'rgba(255,255,255,0.2)',
        borderRightColor: 'rgba(255,255,255,0.1)',
        borderLeftColor: 'rgba(255,255,255,0.05)',
        borderTopColor: 'rgba(255,255,255,0.03)',
    },
    toggleSwitchBackground: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: 999,
    },
    toggleSwitchOn: {
        backgroundColor: 'rgba(255, 255, 255, 0.20)',
    },
    toggleThumb: {
        width: 28,
        height: 28,
        position: 'absolute',
        left: 4,
        top: 3,
        backgroundColor: 'rgba(255, 255, 255, 0.30)',
        borderRadius: 9999,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 2,
        elevation: 2,
    },
    toggleThumbOn: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        shadowOpacity: 0.5,
        shadowRadius: 4,
        elevation: 4,
    },
    actionButtons: {
        width: '100%',
        maxWidth: 900,
        paddingVertical: 24,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        overflow: 'hidden',
        borderTopWidth: 2,
        borderTopColor: 'rgba(255, 255, 255, 0.80)',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 16,
        display: 'flex',
        flexDirection: 'row',
    },
    saveButton: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'rgba(255, 255, 255, 0.80)',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    saveButtonDisabled: {
        opacity: 0.5,
        borderColor: 'rgba(255, 255, 255, 0.40)',
    },
    cancelButton: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'rgba(255, 255, 255, 0.80)',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    autoSaveStatus: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    saveStatusBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        paddingHorizontal: 12,
        paddingVertical: 6,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 16,
    },
    saveStatusText: {
        fontSize: 12,
        fontWeight: '500',
    },
    logoutButton: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'rgba(255, 100, 100, 0.6)',
        backgroundColor: 'rgba(255, 100, 100, 0.1)',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
    },
    buttonText: {
        color: 'rgba(255, 255, 255, 0.80)',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    logoutButtonText: {
        color: 'rgba(255, 100, 100, 0.9)',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    manageSubscriptionButton: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    manageSubscriptionButtonText: {
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: 14,
        fontFamily: 'Slate',
        fontWeight: '400',
        textAlign: 'center',
    },
    mathInput: {
        width: 120,
        height: 40,
    },
    limitInput: {
        width: 80,
        height: 32,
    },
    simpleInputContainer: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        justifyContent: 'center',
    },
    simpleInputText: {
        color: '#B5B5B5',
        fontSize: 16,
        zIndex: 10,
        fontFamily: 'Slate',
        textAlign: 'center',
        fontWeight: '400',
        lineHeight: 22,
        minWidth: 100,
        width: 'auto',
        height: '100%',
        backgroundColor: 'transparent',
        ...(Platform.OS === 'web' && {
            outlineStyle: 'none',
        }),
    },
    // New grid layout styles for filters
    sportsbookFiltersGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 12,
    },
    sportsbookFilterCard: {
        flex: 1,
        minWidth: '22%',
        maxWidth: '24%',
        padding: 8,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.1)',
        alignItems: 'center',
        gap: 4,
    },
    sportsbookFilterCheckbox: {
        alignSelf: 'center',
    },
    sportsbookFilterName: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 12,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 14,
        textAlign: 'center',
    },
    sportsbookFilterLimitInput: {
        width: 50,
        height: 24,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.2)',
        color: '#fff',
        fontSize: 10,
        textAlign: 'center',
        paddingHorizontal: 2,
    },
    showMoreButton: {
        marginTop: 16,
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: 'rgba(162, 89, 255, 0.2)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(162, 89, 255, 0.4)',
        alignSelf: 'center',
    },
    showMoreButtonText: {
        color: '#A259FF',
        fontSize: 14,
        fontFamily: 'Slate',
        fontWeight: '600',
        textAlign: 'center',
    },
    showLessButton: {
        marginTop: 16,
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.2)',
        alignSelf: 'center',
    },
    showLessButtonText: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 14,
        fontFamily: 'Slate',
        fontWeight: '600',
        textAlign: 'center',
    },
    // Missing styles for filters
    preferenceItem: {
        marginBottom: 24,
    },
    sportsbookFiltersContainer: {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 8,
        padding: 16,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.1)',
    },
    preferenceTitle: {
        color: 'rgba(255, 255, 255, 0.9)',
        fontSize: 18,
        fontFamily: 'Slate',
        fontWeight: '600',
        marginBottom: 8,
    },
    preferenceDescription: {
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: 14,
        fontFamily: 'Slate',
        fontWeight: '400',
        lineHeight: 20,
        marginBottom: 16,
    },
    tag: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.2)',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    tagActive: {
        backgroundColor: 'rgba(162, 89, 255, 0.3)',
        borderColor: '#A259FF',
    },
    tagText: {
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: 13,
        fontFamily: 'Slate',
        fontWeight: '500',
    },
    tagTextActive: {
        color: '#fff',
        fontWeight: '600',
    },
    // Query history metric chips
    metricChip: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingVertical: 4,
        paddingHorizontal: 8,
        backgroundColor: 'rgba(139, 92, 246, 0.15)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    metricChipText: {
        color: '#c4b5fd',
        fontSize: 11,
        fontWeight: '600',
    },

    // ── New overhaul styles ─────────────────────────────────────────────────────

    usageStrip: {
        flexDirection: 'column',
        paddingHorizontal: 18,
        paddingVertical: 14,
        backgroundColor: 'rgba(255,255,255,0.04)',
        borderRadius: 14,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.09)',
        marginBottom: 12,
    },
    usageStripLabel: {
        color: 'rgba(255,255,255,0.55)',
        fontSize: 14,
        fontWeight: '600',
        fontFamily: 'Slate',
        letterSpacing: 0.2,
    },
    usageStripCount: {
        color: '#ffffff',
        fontSize: 22,
        fontWeight: '700',
        fontFamily: 'Slate',
    },

    scrollContent: {
        paddingHorizontal: 0,
        paddingTop: 16,
        paddingBottom: 40,
    },

    // Profile header card
    profileHeaderCard: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 14,
        padding: 14,
        backgroundColor: 'rgba(255,255,255,0.04)',
        borderRadius: 14,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.08)',
        marginBottom: 14,
    },
    phcAvatar: {
        width: 54,
        height: 54,
        borderRadius: 27,
        backgroundColor: 'rgba(255,255,255,0.07)',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        flexShrink: 0,
    },
    phcAvatarImg: {
        width: 54,
        height: 54,
        borderRadius: 27,
    },
    phcName: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '600',
        fontFamily: 'Slate',
    },
    phcEmail: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 12,
        marginTop: 1,
        fontFamily: 'Slate',
    },
    phcProgressBg: {
        flex: 1,
        height: 4,
        borderRadius: 2,
        backgroundColor: 'rgba(255,255,255,0.1)',
        overflow: 'hidden',
    },
    phcProgressFill: {
        height: '100%',
        borderRadius: 2,
    },
    phcUsageText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 11,
        fontWeight: '600',
        fontFamily: 'Slate',
    },
    phcPlanBadge: {
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        borderWidth: 1,
    },
    phcPlanText: {
        fontSize: 11,
        fontWeight: '700',
        fontFamily: 'Slate',
    },
    phcSavePill: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(251,191,36,0.4)',
        backgroundColor: 'rgba(0,0,0,0.2)',
    },
    phcSavePillText: {
        fontSize: 10,
        fontWeight: '600',
        fontFamily: 'Slate',
    },

    // Top icon grid
    iconGridWrap: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        marginBottom: 12,
    },
    iconTile: {
        flex: 1,
        minWidth: 80,
        height: 72,
        borderRadius: 14,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 7,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.08)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        position: 'relative',
        paddingTop: 4,
    },
    iconTileActive: {
        borderColor: '#8b5cf6',
        backgroundColor: 'rgba(139,92,246,0.12)',
    },
    iconTileBadge: {
        position: 'absolute',
        top: 7,
        right: 7,
        backgroundColor: '#8b5cf6',
        borderRadius: 8,
        paddingHorizontal: 5,
        paddingVertical: 1,
        minWidth: 16,
        alignItems: 'center',
    },
    iconTileBadgeText: {
        color: '#fff',
        fontSize: 9,
        fontWeight: '700',
    },
    iconTileLabel: {
        fontSize: 10,
        color: 'rgba(255,255,255,0.45)',
        fontWeight: '600',
        textAlign: 'center',
        fontFamily: 'Slate',
    },
    iconTileLabelActive: {
        color: '#a78bfa',
    },

    // Settings sub-nav
    subNavSticky: {
        paddingVertical: 8,
        backgroundColor: 'rgba(14,13,18,0.92)',
        ...(Platform.OS === 'web' ? { backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)' } : {}),
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.06)',
        zIndex: 5,
    },
    subNavTileHover: {
        backgroundColor: 'rgba(255,255,255,0.07)',
        borderColor: 'rgba(255,255,255,0.16)',
    },
    subNavWrap: {
        flexDirection: 'row',
        gap: 6,
        marginBottom: 12,
        flexWrap: 'wrap',
    },
    subNavTile: {
        flex: 1,
        minWidth: 62,
        height: 58,
        borderRadius: 12,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 5,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.07)',
        backgroundColor: 'rgba(255,255,255,0.02)',
    },
    subNavTileActive: {
        borderColor: 'rgba(139,92,246,0.35)',
        backgroundColor: 'rgba(139,92,246,0.08)',
    },
    subNavLabel: {
        fontSize: 9,
        fontWeight: '700',
        color: 'rgba(255,255,255,0.38)',
        textAlign: 'center',
        fontFamily: 'Slate',
        letterSpacing: 0.2,
        textTransform: 'uppercase',
    },

    // Section card
    sectionCard: {
        borderRadius: 16,
        borderWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.12)',
        borderLeftColor: 'rgba(255,255,255,0.07)',
        borderRightColor: 'rgba(255,255,255,0.05)',
        borderBottomColor: 'rgba(255,255,255,0.04)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        overflow: 'hidden',
        marginBottom: 16,
    },
    sectionHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingHorizontal: 20,
        paddingVertical: 14,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.07)',
    },
    sectionHeaderText: {
        fontSize: 14,
        fontWeight: '600',
        color: 'rgba(255,255,255,0.75)',
        fontFamily: 'Slate',
    },
    sectionBody: {
        padding: 16,
    },
    sectionDivider: {
        height: 1,
        backgroundColor: 'rgba(255,255,255,0.07)',
        marginVertical: 8,
    },

    // Sub-section header (inside a section card)
    subsectionHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginBottom: 6,
        marginTop: 4,
    },
    subsectionTitle: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 15,
        fontWeight: '600',
        fontFamily: 'Slate',
    },
    subsectionDescription: {
        color: 'rgba(255,255,255,0.45)',
        fontSize: 13,
        lineHeight: 18,
        marginBottom: 12,
        fontFamily: 'Slate',
    },

    // Avatar upload (in profile section)
    avatarUpload: {
        width: 60,
        height: 60,
        borderRadius: 30,
        backgroundColor: 'rgba(255,255,255,0.07)',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        borderWidth: 2,
        borderColor: 'rgba(139,92,246,0.3)',
    },
    avatarUploadImg: {
        width: 60,
        height: 60,
        borderRadius: 30,
    },
    avatarUploadPlaceholder: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },

    // Logout row
    logoutRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingVertical: 12,
    },
    logoutRowText: {
        color: '#f87171',
        fontSize: 15,
        fontWeight: '500',
        fontFamily: 'Slate',
    },

    // Empty state
    emptyState: {
        alignItems: 'center',
        paddingVertical: 40,
        gap: 12,
    },
    emptyStateText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 14,
        textAlign: 'center',
        fontFamily: 'Slate',
        maxWidth: 280,
    },

    // Option buttons (sort, bet mode, kelly presets)
    optBtn: {
        paddingVertical: 7,
        paddingHorizontal: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.18)',
        backgroundColor: 'rgba(255,255,255,0.04)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    optBtnText: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 13,
        fontWeight: '500',
        fontFamily: 'Slate',
    },

    // Stepper control
    stepper: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 8,
        overflow: 'hidden',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.12)',
        flexShrink: 0,
    },
    stepperBtnHover: {
        backgroundColor: 'rgba(255,255,255,0.14)',
    },
    stepperBtn: {
        width: 34,
        height: 38,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255,255,255,0.06)',
    },
    stepperBtnText: {
        color: 'rgba(255,255,255,0.75)',
        fontSize: 18,
        fontWeight: '300',
        lineHeight: 22,
    },
    stepperValueWrap: {
        paddingHorizontal: 12,
        height: 38,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 52,
        backgroundColor: 'rgba(255,255,255,0.02)',
    },
    stepperValueText: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 14,
        fontWeight: '600',
        textAlign: 'center',
        fontFamily: 'Slate',
    },
});
